// Import React
import { useEffect } from "react";

// Import React-Redux
import { useDispatch } from "react-redux";

// Import Auth Actions
import { fetchUser } from "./actions/AuthAction";

import authConfig from "src/configs/auth";

const AuthHandler = ({ children }) => {
  const dispatch = useDispatch();

  // Fetch user on initialization
  useEffect(() => {
    const storedToken = window.localStorage.getItem(authConfig.storageTokenKeyName)
    if (storedToken) {
      dispatch(fetchUser({ storedToken: storedToken }));
    }
  }, [dispatch]);

  return children;
};

export default AuthHandler;
